import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/emails`;

export const getAll = async ({page = '', limit = '', numDocument = '', email = ''}) => {
 const {data} = await axios.get(`${baseUrl}/?page=${page}&limit=${limit}&numDocument=${numDocument}&email=${email}`, config) 
 return data
}

export const create = async ({email = {}}) => {
 const {data} = await axios.post(baseUrl, email, config)
 return data
}

export const update = async ({email = {}, id}) => {
 const {data} = await axios.put(`${baseUrl}/${id}`, email, config)
 return data
}

export const del = async ({id}) => {
 const {data} = await axios.delete(`${baseUrl}/${id}`, config)
 return data
}

export const getVinculedEmailsWithClient = async ({numDocument = "undefined"}) => {
    if(!numDocument || numDocument === "undefined"){
        numDocument = "undefined"
    }
    const {data} = await axios.get(`${baseUrl}/findVinculedEmails/${numDocument}`, config)
    return data
}

export const desvinculedEmail = async ({idEmail, idCliente}) => {
    const {data} = await axios.get(`${baseUrl}/desvinculedEmail/${idEmail}/${idCliente}`, config) 
    return data
}

export const vinculedEmail = async ({idEmail, idCliente}) => {
    const {data} = await axios.get(`${baseUrl}/vinculedEmail/${idEmail}/${idCliente}`, config) 
    return data
}